module.exports = __webpack_public_path__ + "img/Wiliams.57265c2a.jpeg";